import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../components/SectionHeader';
import { Button } from '../components/Button';
import { FAQAccordion } from '../components/FAQAccordion';
import { GlowOrb } from '../components/GlowOrb';
import { faqs } from '../data/content';
import { Mail, MessageCircle, MapPin, Clock } from 'lucide-react';
export function Contact() {
  return <div className="pt-32 pb-24 relative overflow-hidden" data-id="element-496">
      <div className="absolute inset-0 bg-cover bg-center opacity-15" style={{
      backgroundImage: `url(https://images.unsplash.com/photo-1518791841217-8f162f1e1131?q=80&w=2000&auto=format&fit=crop)`
    }} data-id="element-497"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-midnight/90 to-midnight" data-id="element-498"></div>
      <GlowOrb color="primary" size="xl" position="top-0 left-0" data-id="element-499" />
      <GlowOrb color="gold" size="lg" position="bottom-0 right-0" delay={3} data-id="element-500" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-501">
        <SectionHeader eyebrow="Get In Touch" title="Connect With Us" description="Have questions about our services or need help choosing the right healing path? We are here to guide you." data-id="element-502" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mt-20 max-w-7xl mx-auto" data-id="element-503">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} className="lg:col-span-7 glass p-10 md:p-16 rounded-[3rem]" data-id="element-504">
            <h3 className="text-3xl font-serif text-white mb-8" data-id="element-505">
              Send a Message
            </h3>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-506">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-507">
                <div className="space-y-3" data-id="element-508">
                  <label className="text-sm font-medium text-beige uppercase tracking-wider" data-id="element-509">
                    Name
                  </label>
                  <input type="text" className="w-full px-5 py-4 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white transition-all" data-id="element-510" />
                </div>
                <div className="space-y-3" data-id="element-511">
                  <label className="text-sm font-medium text-beige uppercase tracking-wider" data-id="element-512">
                    Email
                  </label>
                  <input type="email" className="w-full px-5 py-4 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white transition-all" data-id="element-513" />
                </div>
              </div>
              <div className="space-y-3" data-id="element-514">
                <label className="text-sm font-medium text-beige uppercase tracking-wider" data-id="element-515">
                  Subject
                </label>
                <input type="text" className="w-full px-5 py-4 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white transition-all" data-id="element-516" />
              </div>
              <div className="space-y-3" data-id="element-517">
                <label className="text-sm font-medium text-beige uppercase tracking-wider" data-id="element-518">
                  Message
                </label>
                <textarea rows={6} className="w-full px-5 py-4 rounded-xl bg-midnight/50 border border-white/10 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold text-white transition-all resize-none" data-id="element-519"></textarea>
              </div>
              <Button type="submit" size="lg" variant="primary" className="mt-4" data-id="element-520">
                Send Message
              </Button>
            </form>
          </motion.div>

          {/* Info Cards */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} className="lg:col-span-5 space-y-6" data-id="element-521">
            <div className="glass p-8 rounded-3xl flex items-start gap-6 hover:border-gold/30 transition-colors" data-id="element-522">
              <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-523">
                <Mail className="w-6 h-6 text-gold" data-id="element-524" />
              </div>
              <div data-id="element-525">
                <h4 className="font-serif text-xl text-white mb-2" data-id="element-526">Email Us</h4>
                <p className="text-beige-muted text-sm mb-2" data-id="element-527">
                  For general inquiries and support.
                </p>
                <a href="mailto:support@calmoras.online" className="text-gold hover:text-white transition-colors font-medium" data-id="element-528">
                  support@calmoras.online
                </a>
              </div>
            </div>

            <div className="glass p-8 rounded-3xl flex items-start gap-6 hover:border-gold/30 transition-colors" data-id="element-529">
              <div className="w-14 h-14 rounded-full bg-[#25D366]/10 flex items-center justify-center flex-shrink-0" data-id="element-530">
                <MessageCircle className="w-6 h-6 text-[#25D366]" data-id="element-531" />
              </div>
              <div data-id="element-532">
                <h4 className="font-serif text-xl text-white mb-2" data-id="element-533">WhatsApp</h4>
                <p className="text-beige-muted text-sm mb-2" data-id="element-534">
                  For immediate assistance and free readings.
                </p>
                <a href="https://wa.me/1234567890" className="text-gold hover:text-white transition-colors font-medium" data-id="element-535">
                  +1 (234) 567-890
                </a>
              </div>
            </div>

            <div className="glass p-8 rounded-3xl flex items-start gap-6 hover:border-gold/30 transition-colors" data-id="element-536">
              <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-537">
                <Clock className="w-6 h-6 text-gold" data-id="element-538" />
              </div>
              <div data-id="element-539">
                <h4 className="font-serif text-xl text-white mb-2" data-id="element-540">
                  Response Time
                </h4>
                <p className="text-beige-muted text-sm" data-id="element-541">
                  We aim to respond to all inquiries within 24 hours during
                  business days.
                </p>
              </div>
            </div>

            <div className="bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=1000&auto=format&fit=crop')] bg-cover bg-center p-8 rounded-3xl relative overflow-hidden h-48 flex items-end" data-id="element-542">
              <div className="absolute inset-0 bg-midnight/60" data-id="element-543"></div>
              <div className="relative z-10 flex items-center gap-4" data-id="element-544">
                <MapPin className="w-6 h-6 text-gold" data-id="element-545" />
                <p className="text-white font-medium" data-id="element-546">
                  Serving souls worldwide in 50+ countries.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* FAQs */}
        <div className="mt-32 max-w-3xl mx-auto" data-id="element-547">
          <h3 className="text-3xl font-serif text-white mb-10 text-center" data-id="element-548">
            Frequently Asked Questions
          </h3>
          <FAQAccordion items={faqs} data-id="element-549" />
        </div>
      </div>
    </div>;
}